import moment from 'moment';
import { useState, useEffect } from 'react';

moment.updateLocale('en', {
  relativeTime: {
    future: '%s remaining',
    m: 'one minute',
    h: 'one hour',
    d: 'one day',
    w: 'one week',
    M: 'one month',
    y: 'one year',
  },
});

export default function useDateMoment(date) {
  const [state, setState] = useState(moment());

  useEffect(() => {
    setState(moment.utc(date, moment.ISO_8601));
  }, [date]);

  return [state, state.local().format('MMMM Do YYYY, h:mm:ss a')];
}
